import { Provider } from '@angular/core';
import { DataApi } from './data.api';
import { NotificationsApi } from './notifications.api';
import { OperatorsApi } from './operators.api';
import { RoutingApi } from './routing.api';
import { SettingsApi } from './settings.api';
import { environment } from 'src/environment/environment';
import { API_BASE_URL, US_BASE_URL } from './tokens';

export * from './model';
export * from './data.api';
export * from './notifications.api';
export * from './operators.api';
export * from './routing.api';
export * from './settings.api';

export const apiProviders: Provider[] = [
  DataApi,
  NotificationsApi,
  OperatorsApi,
  RoutingApi,
  SettingsApi,
  { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  { provide: US_BASE_URL, useValue: environment.usBaseUrl },
];
